import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import {
  SelectFieldMultiList,
  type SelectFieldMultiListProps,
} from 'shared/ui/Select/SelectMultiListField/SelectMultiListField.tsx'
import { type IDropdownItem } from 'shared/ui'
import { ChipWithAvatar } from 'entities/Phone/ui/AssignNumberCommon/ui/ChipWithAvatar/ChipWithAvatar.tsx'
import { MultiSelectDropdownContent } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/MultiSelectDropdownContent.tsx'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IUser } from 'entities/Users'
import styles from './styles.module.scss'

export const MultiSelectMembers = observer(
  ({
    labelProps,
    values,
    setValues,
    filterMembersDropdownItems,
  }: {
    labelProps: SelectFieldMultiListProps['labelProps']
    values: number[]
    setValues: (values: number[]) => void
    filterMembersDropdownItems?: (item: IDropdownItem<IUser>) => boolean
  }) => {
    const { usersStore } = useEntitiesContext()
    const { membersDropdownItems: membersDropdownItemsStore } = usersStore

    const membersDropdownItems = filterMembersDropdownItems
      ? membersDropdownItemsStore.filter(filterMembersDropdownItems)
      : membersDropdownItemsStore

    const [selectedMembers, setSelectedMembers] = useState<IDropdownItem[]>([])

    const selectedMembersItems = selectedMembers.map((item) => ({
      id: item.id,
      label: item.label,
      value: item.value,
      data: {
        isAway: undefined,
        avatarInfo: item.avatarProps?.info,
      },
    }))

    const handleSelectedMembers = (items: IDropdownItem[]) => {
      setSelectedMembers(items)
      setValues(items.map((item) => Number(item.id)))
    }

    const setSelectedMember = (item: IDropdownItem) => {
      handleSelectedMembers([...selectedMembers, item])
    }

    const deleteSelectedMembers = (value: IDropdownItem) => {
      handleSelectedMembers(selectedMembers.filter((item) => item.id !== value.id))
    }

    useEffect(() => {
      if (values.length) {
        usersStore.initPromise.then(() => {
          handleSelectedMembers(
            membersDropdownItems.filter((item) => values.includes(Number(item.id)))
          )
        })
      }
    }, [])

    return (
      <SelectFieldMultiList
        withInitialSearch
        ChipComponent={ChipWithAvatar}
        labelProps={labelProps}
        dropdownProps={{
          textFieldProps: {
            className: classNames(styles.selectMembersPadding, {
              [styles.empty]: !selectedMembersItems.length,
            }),
          },
          PopperProps: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  offset: ({ reference }) => {
                    return [0, -reference.height - 8]
                  },
                },
              },
            ],
          },
        }}
        items={membersDropdownItems}
        selectedItems={selectedMembersItems}
        onDelete={deleteSelectedMembers}
        onSelect={setSelectedMember}
        fullWidth
        customComponent={() => (
          <MultiSelectDropdownContent
            ChipComponent={ChipWithAvatar}
            items={membersDropdownItems}
            selectedItems={selectedMembersItems}
            onSelect={setSelectedMember}
            onDelete={deleteSelectedMembers}
            shouldShowNotFoundText
          />
        )}
      />
    )
  }
)
